import { constants } from "../../../constants";

export default class GameLaunchUrl {
    constructor(gb) {
        Object.assign(this, { gb });
    }

    _default(data) {
        this.gb.emitters.emit.game.setLaunchUrl(data);
    }

    exposeEvent() {
        let event = {};

        switch (this.gb.walletProtocol) {
            default:
                event["setGameLaunchUrl"] = this._default
        }

        return event;
    }
}
